import tools from "../../tools";
import Paging from "../Paging/Paging.vue";

export default {
    name: "expoolExercise",
    components: {
        Paging: Paging
    },
    props: ['exercisePoolId', 'IsEditor', 'activeChapterId', 'isOCRExercisePool', 'activeChapterName', 'isSearch', 'jing', 'Statu', 'fromBeike','subjectCourse'],  //Statu=1=已使用
    data() {
        return {
            chapterId: this.activeChapterId,
            chapterIds: "", //选章时返回所有小节id集合

            isLoading: false,
            isNothing: false,

            subjectCourseId: "",
            exerciseTypeList: [], //题型列表
            isShowExerciseTypeList: false,
            exerciseTypeId: -1, //-1==全部 因为接口会返回选择题=0
            exerciseTypeName: "全部题型",
            exerciseTypeAliasList: [], //题型别名列表
            exerciseTypeAliasId: 0,

            pageIndex: 1,
            rowsCount: 10,
            orderby: "0", // 默认ReviewDate asc  升序=0=ReviewDate asc   降序=1=ReviewDate desc
            totalPage: "",
            totalRowsCount: "",
            ExerciseList: [],

            isBatchOption: false, //批量操作
            isSelectAllExercise: false,
            batchExerciseIds: [], //选择习题ID集合
            batchType: "", //批量操作方式  库内迁移(move)、批量采用(use)、批量复制(copy)、批量删除(del)
            batchOrSingle: "", //批量还是单个习题  batch\single
            //库内迁移
            isShowCatalogList: false, //选择题库章节
            exercisePoolChapterList: [], //题库章节
            exercisePoolChapterActiveChapterId: -1,
            //批量采用&复制
            isShowCopyExercisePoolList: false,
            copyExercisePoolList: [], //题库集合
            copyExercisePoolId: 0, //批量复制的题库ID
            copyExercisePoolText: "", //关键字搜索
            copyExercisePoolChapterList: [], //题库章节
            copyExercisePoolChapterActiveChapterId: -1,

            viewType: 0, //查看习题模式 0=精简，1=预览

            //创建&编辑习题
            isShowEditExerciseList: false,
            editExerciseType: 0, //0=创建，1=编辑 2=重新录入 3=更换题型
            editExerciseId: "",
            editExerciseIframeSrc: "", //习题地址
            editExerciseIframeLoading: false,
            //创建&编辑习题提示消息
            isShowEditExerciseIframeConfim: false,
            editExerciseIframeCallback: "", //回调方法

            //复制习题的编辑模态框
            isShowCopyEditExerciseList: false,
            copyExerciseId: "",
            copyExerciseIframeSrc: "", //习题地址
            copyExerciseIframeLoading: false,

            //题号和页码
            pageOrderList: [], //页码排序集合
            pageOrderId: "",
            pageOrderName: "全部",
            isShowCreatePageNum: false, //生成页码模态框
            createPageNumType: "input", //填input\选select
            PageNumCount: 0, //填的数
            PageNumList: [], //选的值
            PageNumId: 0,
            PageNumName: "",
            isShowCreatePageNumError: false,
            searchtext: '',//搜索内容
            oldpageNum: [],//题库下已有的页码
            remarklist: '', //树状图
            annotationDig: false,
            defaultProps: {
                children: 'SubEChapters',
                label: 'EChapterName'
            },
            AHZtype: '',
            AHZtypelist: [
                {
                    value: '0',
                    label: '生成页码'
                },
                {
                    value: '1',
                    label: '库内迁移'
                },
                {
                    value: '2',
                    label: '批量采用'
                },
                {
                    value: '3',
                    label: '批量删除'
                },
            ],
            //习题视觉还原sdk的配置项
            config: {
                LazyLoad: false,
                BlankInnerText: '__[Num]__'
            },
            rightOptions: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'S', 'Y', 'Z'],
        }
    },
    mounted() {
        console.log('exerciseMounted')

        //加载latex
        // tools.GetLatexWebsite();
        //加载字体
        tools.GetFonStyle();
        this.$nextTick(function () {
            HexSelector.init();
        });
        let _this = this;
        console.log(_this.subjectCourse)
        //接收信息
        window.removeEventListener('message', _this.exerciseInputIframeEventListener, false);
        window.addEventListener('message', _this.exerciseInputIframeEventListener, false);
        window.removeEventListener('message', _this.exerciseCopyIframeEventListener, false);
        window.addEventListener('message', _this.exerciseCopyIframeEventListener, false);
    },
    updated() {
        this.$nextTick(function () {
            HexExerciseTransform.renderImage($(".exercise"), function () {
                // console.log("图片渲染完毕")
            });

            let _this = this;
            $("html").on("click", "body", function (event) {
                _this.isShowExerciseTypeList = false;
            });
        });
    },
    methods: {
        init: function (chapterId, chapterIds, searchtext) {
            let _this = this;
            _this.chapterId = chapterId;
            _this.chapterIds = chapterIds;
            _this.exerciseTypeAliasList = [];
            _this.exerciseTypeId = -1;
            _this.exerciseTypeAliasId = 0;
            _this.exerciseTypeName = "全部题型";
            _this.isShowExerciseTypeList = false;
            _this.closeBatchOption();
            _this.viewType = 0;
            _this.orderby = 0;
            _this.pageOrderId = "";
            _this.pageOrderName = "全部";
            _this.pageIndex = 1;
            _this.searchtext = searchtext;

            this.getExerciseBookSubjectCourse(function () {
                _this.getExerciseType();
            });
            this.getExerciseList();

            this.getPageOrderList();

            this.setFontSize();
            // let _this = this;
            // _this.chapterId = chapterId;
            // _this.chapterIds = chapterIds;
            // _this.exerciseTypeAliasList = [];
            // _this.exerciseTypeId = -1;
            // _this.exerciseTypeAliasId = 0;
            // _this.exerciseTypeName = "全部题型";
            // _this.isShowExerciseTypeList = false;
            // _this.closeBatchOption();
            // _this.viewType = 0;
            // _this.orderby = 0;
            // _this.pageOrderId = "";
            // _this.pageOrderName = "全部";
            // _this.pageIndex = 1;
            // this.getExerciseBookSubjectCourse(function () {
            //     _this.getExerciseType();
            // });
            // _this.searchtext = searchtext;
            // this.getExerciseList();
            // this.getPageOrderList();

            // if(chapterId==0){
            //     _this.searchtext = searchtext;
            //     this.getExerciseList();
            //     _this.ExerciseList = [];
            //     this.isLoading = true
            // }else{
            //     _this.chapterId = chapterId;
            //     _this.chapterIds = chapterIds;
            //     this.getExerciseList();
            //     this.getPageOrderList();
            // }
        },
        getExerciseBookSubjectCourse: function (callback) {
            let _this = this;
            tools.api('ExercisesPool.GetExerciseBookSubjectCourse', {"ExerciseBookID": _this.exercisePoolId}, (data) => {
                if (data) {
                    _this.subjectCourseId = data.subjectCourseID;
                    if (typeof callback == "function") {
                        callback();
                    }
                }
            });
        },
        //获取习题类型
        getExerciseType: function () {
            let _this = this;
            _this.exerciseTypeList = [];
            tools.api(
                'ExercisesPool.SearchExerciseTypeAliasBySubjectCourseIdAsync',
                {"subjectCourseId": _this.subjectCourseId},
                function (data) {
                    if (data != null) {
                        let ExerciseTypeId = [];
                        for (let item of data) {
                            //筛选基础题型
                            if (ExerciseTypeId.indexOf(item.ExerciseType) <= -1) {
                                ExerciseTypeId.push(item.ExerciseType);
                                _this.exerciseTypeList.push({
                                    "ExerciseTypeId": item.ExerciseTypeId,
                                    "ExerciseTypeName": item.ExerciseType,
                                    "ExerciseTypeAliasList": []
                                });
                            }
                        }

                        for (let item of _this.exerciseTypeList) {
                            item.ExerciseTypeAliasList = data.filter(function (el) {
                                return el.ExerciseTypeId == item.ExerciseTypeId
                            })
                        }
                        _this.exerciseTypeList = _this.exerciseTypeList.sort(function (a, b) {
                            return a.ExerciseTypeId - b.ExerciseTypeId
                        })
                    }
                }
            )
        },
        //搜索出习题

        // searchExerciseList:function(){
        //     let _this = this;
        //     tools.api('ExercisesPool.GetExerciseListByExercisePool', {
        //         "poolid": _this.exercisePoolId,
        //         'search':_this.searchtext,
        //         'exerciseType':_this.exerciseTypeAliasId == 0 ? "" : _this.exerciseTypeAliasId,
        //         "page": _this.pageIndex,
        //         "rows": _this.rowsCount,
        //     }
        //         , (data) => {
        //         let ExerciseList = [];
        //         data.Exercises.forEach(function (item) {
        //             let Exercise = _this.ExerciseModel();
        //             _this.SetExercise(Exercise, item);
        //             //console.log(Exercise);
        //             ExerciseList.push(Exercise)
        //         })
        //         _this.totalPage = data.Pagination.TotalPagesCount;
        //         _this.totalRowsCount = data.Pagination.TotalRowsCount;
        //         _this.$refs.htePaging.init(_this.pageIndex, _this.rowsCount, _this.totalRowsCount, _this.totalPage);

        //         //没有习题
        //         if (ExerciseList.length <= 0) {
        //             _this.closeBatchOption();
        //             _this.isLoading = false;
        //             return false;
        //         }
        //         //console.log(ExerciseList)
        //         _this.getExerciseInfoList(tools.cloneJson(ExerciseList));
        //     });
        // },


        //获取习题
        getExerciseList: function () {
            let _this = this;
            _this.ExerciseList = [];
            _this.isLoading = true;
            tools.api('ExercisesPool.GetExerciseListByExercisePoolNew', {
                "poolid": _this.exercisePoolId,
                "search": _this.searchtext,
                "chapterid": _this.chapterIds == -1 ? undefined : _this.chapterIds, //-1的时候，是检索全部习题
                "exerciseType": _this.exerciseTypeAliasId == 0 ? "" : _this.exerciseTypeAliasId,
                "keypoints": "",
                "page": _this.pageIndex,
                "rows": _this.rowsCount,
                "orderby": _this.orderby == 0 ? 'ReviewDate asc' : 'ReviewDate desc',
                "pageNum": _this.pageOrderId, //页码(获取全部传全部；获取未标记传未标记；否则传页码)
                'IsOCR': _this.isOCRExercisePool == true ? 1 : 0
            }, (data) => {
                let ExerciseList = [];
                data.Exercises.forEach(function (item) {
                    let Exercise = _this.ExerciseModel();
                    _this.SetExercise(Exercise, item);
                    ExerciseList.push(Exercise)
                })
                _this.totalPage = data.Pagination.TotalPagesCount;
                _this.totalRowsCount = data.Pagination.TotalRowsCount;
                _this.$refs.htePaging.init(_this.pageIndex, _this.rowsCount, _this.totalRowsCount, _this.totalPage);

                //没有习题
                if (ExerciseList.length <= 0) {
                    _this.closeBatchOption();
                    _this.isLoading = false;
                    return false;
                }

                _this.getExerciseInfoList(tools.cloneJson(ExerciseList));
            });
        },
        //新生成习题模型
        ExerciseModel: function () {
            var Exercise = {};
            Exercise.ExerciseId = "";
            Exercise.Score = "";
            Exercise.ExerciseSubject = "";
            Exercise.ExerciseSubjectEX = "";
            Exercise.ExerciseType = "";
            Exercise.ET = "";
            Exercise.Note = "";
            Exercise.DifficultLevel = 0;
            Exercise.Tips = [];
            Exercise.ExerciseTypeAliasID = 0;
            Exercise.ExerciseTypeAliasName = "";
            Exercise.KeyPointList = "";
            Exercise.Accouracy = 0.0;//正确率
            Exercise.UseCount = 0;
            Exercise.Remark = "";
            Exercise.IsChildOnly = false;//是否是计算题的小题
            Exercise.KeyPointName = "";

            //大题内的小题
            Exercise.Questions = [];
            //选择题选项
            Exercise.IsSingleChoice = true;
            Exercise.AnswersOptions = [];
            //选择题答案
            Exercise.CorrectAnswer = "";
            Exercise.CorrectAnswerStr = "";
            //主观题答案
            Exercise.SubjectiveAnswer = "";
            //判断题答案
            Exercise.CAnswer = false;
            //填空题答案
            Exercise.FillBlankAnswers = [];
            Exercise.FillBlankAnswersStr = [];
            //选择填空题答案
            Exercise.ChoiceFillBlankAnswers = [];
            Exercise.ChoiceFillBlankAnswersStr = [];

            //页码和题号
            Exercise.Page = "";
            Exercise.Number = "";

            Exercise.ElementNames = '';

            return Exercise;
        },
        //设置习题  Exercise源数据，data请求到的数据
        SetExercise: function (Exercise, data) {
            Exercise.ElementNames = data.ElementNames
            Exercise.ExerciseId = data.ExerciseId;
            // Exercise.ExerciseSubject = data.ExerciseSubject;
            //添加筛选条件
            Exercise.ExerciseSubject = tools.replaceKeywords(data.ExerciseSubject, this.searchtext)
            // console.log(Exercise.ExerciseSubject)
            Exercise.Score = data.Score;
            Exercise.ExerciseSubjectEX = data.ExerciseSubjectEX;
            Exercise.ET = data.ET;
            Exercise.Note = data.Note;
            Exercise.DifficultLevel = data.DifficultLevel;
            Exercise.Tips = data.Tips;
            Exercise.ExerciseTypeAliasID = data.ExerciseTypeAliasID;
            Exercise.ExerciseType = data.ExerciseType || data.AliasName;
            Exercise.ExerciseTypeAliasName = data.AliasName;
            Exercise.Accouracy = data.Accouracy;
            Exercise.UseCount = data.UseCount;
            Exercise.Remark = data.Remark;
            Exercise.IsChildOnly = data.IsChildOnly;
            Exercise.sectionID = data.EChapterID
            if (Exercise.ET == "Choice") {
                Exercise.AnswersOptions = data.AnswersOptions;
                Exercise.CorrectAnswerStr = data.CorrectAnswerStr;
                Exercise.CorrectAnswer = data.CorrectAnswer;
                Exercise.IsSingleChoice = data.IsSingleChoice;
            } else if (Exercise.ET == "Subjective") {
                Exercise.SubjectiveAnswer = data.SubjectiveAnswer;
            } else if (Exercise.ET == "Judgment") {
                Exercise.CAnswer = data.CAnswer;
            } else if (Exercise.ET == "FillBlank") {
                Exercise.FillBlankAnswers = data.FillBlankAnswers;
                Exercise.FillBlankAnswersStr = data.FillBlankAnswers;
            } else if (Exercise.ET == "ChoiceFillBlank") {
                Exercise.ChoiceFillBlankAnswers = data.ChoiceFillBlankAnswers;
                Exercise.ChoiceFillBlankAnswersStr = data.ChoiceFillBlankAnswersStr;
            } else if (Exercise.ET == "Compute" || Exercise.ET == "LargeChoiceFillBlank") {
                Exercise.Questions = data.Questions;
            }
        },
        //获取答案，题解等信息
        getExerciseInfoList: function (ExerciseList) {

            let _this = this;
            let ids = [];
            ExerciseList.forEach(function (item) {
                ids.push(item.ExerciseId)
            })
            if (ids.length <= 0) {
                _this.isLoading = false;
                return false;
            }
            let ExerciseList1 = []
            tools.api('Exercise.ExerciseList', {"ids": ids.join(",")}, (data) => {
                data.forEach(function (item) {
                    //给子题补充KeyPointName属性
                    if (item.Questions != undefined && item.Questions.length > 0) {
                        item.Questions.forEach(function (Questions) {
                            Questions.KeyPointName = "";
                        })
                    }

                    let extend = ExerciseList.find(el => {
                        return el.ExerciseId == item.ExerciseId
                    })

                    item = Object.assign(extend, item);
                    // _this.getExerciseKeyPoint(item.ExerciseId, function (KeyPointName) {
                    //     item.KeyPointName = KeyPointName;
                    // })

                    //显示答案
                    if (item.ET == "Choice") {
                        _this.GetChoiceAnswerStrByContent(item);
                    } else if (item.ET == "FillBlank") {
                        _this.GetFillBlankAnswersStr(item);
                    } else if (item.ET == "ChoiceFillBlank") {
                        _this.GetChoiceFillBlankAnswersStr(item);
                    } else if (item.ET == "Compute" || item.ET == "LargeChoiceFillBlank") {
                        item.Questions.forEach(function (Questions) {
                            if (Questions.ET == "Choice") {
                                _this.GetChoiceAnswerStrByContent(Questions);
                            } else if (Questions.ET == "FillBlank") {
                                _this.GetFillBlankAnswersStr(Questions);
                            } else if (Questions.ET == "ChoiceFillBlank") {
                                _this.GetChoiceFillBlankAnswersStr(Questions);
                            }
                            // _this.getExerciseKeyPoint(Questions.ExerciseId, function (KeyPointName) {
                            //     Questions.KeyPointName = KeyPointName;
                            // })
                        })
                    }
                    //添加搜索过滤
                    //  var newexe = HexExerciseTransform.jsonTransform(item);
                    item.ExerciseSubject = tools.replaceKeywords(item.ExerciseSubject, _this.searchtext)
                    //  _this.ExerciseList.push(newexe);
                    ExerciseList1.push(item)
                })
                _this.drawExerciseList(ExerciseList1).then((data) => {
                    _this.ExerciseList = tools.cloneJson(data)
                    _this.getExercisePageAndNumber(_this.ExerciseList);
                })
                if (_this.viewType == 1) {
                    _this.getExerciseKeyPointList(_this.ExerciseList);
                }
                _this.isLoading = false;
                try {
                    _this.ExerciseList.forEach((i, n) => {
                        if (_this.batchExerciseIds.indexOf(i.ExerciseId) == -1) {
                            _this.isSelectAllExercise = false

                            throw Error();
                        } else {
                            _this.isSelectAllExercise = true

                        }
                    })
                } catch (e) {
                }

                // //渲染latex
                // _this.$nextTick(function () {
                //     tools.initLatex($(".exercise"));
                //     tools.initImg($(".exercise"));
                // })
            });
        },
        /**
         * 习题视觉还原(题数组)
         * @param needDrawExeList 需要转换的题数组
         */
        drawExerciseList(needDrawExeList) {
            let _this = this
            return new Promise((resolve, reject) => {
                HexDrawExe.drawExerciseModel1List(needDrawExeList, _this.config).then((exeList) => {
                    for (let newData of exeList) {
                        for (let realExe of needDrawExeList) {
                            if (newData.ExerciseId == realExe.ExerciseId) {
                                realExe.Note = newData.Explain
                                realExe.ExerciseSubject = newData.Subject;
                                realExe.AnswersOptions = newData.Options;
                                realExe.ChildExerciseHTMLStringList = newData.ChildExerciseHTMLStringList;
                                if (realExe.ET === 'Compute' || realExe.ET == "LargeChoiceFillBlank") {
                                    //组合题小题
                                    let childExercise = newData.ChildExerciseHTMLStringList;
                                    for (let sonExe of realExe.Questions) {
                                        for (let newSonExe of childExercise) {
                                            if (sonExe.ExerciseId == newSonExe.ExerciseId) {
                                                sonExe.ExerciseSubject = newSonExe.Subject;
                                                sonExe.AnswersOptions = newSonExe.Options;
                                                sonExe.Note = newSonExe.Explain
                                                if (sonExe.ET === 'Choice') {
                                                    sonExe.CorrectAnswer = newSonExe.Answer
                                                } else if (sonExe.ET === 'FillBlank') {
                                                    sonExe.FillBlankAnswers = newSonExe.Answer
                                                } else if (sonExe.ET === 'Subjective') {
                                                    sonExe.SubjectiveAnswer = newSonExe.Answer
                                                } else if (sonExe.ET === 'Judgment') {
                                                    sonExe.CAnswer == newSonExe.Answer
                                                } else if (sonExe.ET === 'ChoiceFillBlank') {
                                                    sonExe.ChoiceFillBlankAnswers = newSonExe.Answer
                                                }
                                            }
                                        }
                                    }
                                }
                                if (realExe.ET === 'Choice') {
                                    realExe.CorrectAnswer = newData.Answer
                                } else if (realExe.ET === 'FillBlank') {
                                    realExe.FillBlankAnswers = newData.Answer
                                } else if (realExe.ET === 'Subjective') {
                                    realExe.SubjectiveAnswer = newData.Answer
                                } else if (realExe.ET === 'Judgment') {
                                    realExe.CAnswer == newData.Answer
                                } else if (realExe.ET === 'ChoiceFillBlank') {
                                    realExe.ChoiceFillBlankAnswers = newData.Answer
                                }
                            }
                        }
                    }
                    resolve(needDrawExeList);
                })
            })
        },
        //获取选择题正确答案字符串
        GetChoiceAnswerStrByContent: function (Exercise) {
            Exercise.CorrectAnswerStr = "";
            if (Exercise.CorrectAnswer.length > 0) {
                Exercise.CorrectAnswerStr = "";
                var choiceanswer = Exercise.CorrectAnswer.split("");
                for (var i = 0; i < choiceanswer.length; i++) {
                    if (choiceanswer[i] == "1") {
                        Exercise.CorrectAnswerStr += "<div><span>" + String.fromCharCode(i + 65) + "、</span><div style='display: inline-block;max-width: 100%;'>" + Exercise.AnswersOptions[i] + "</div></div>";
                    }
                }
            }
        },
        //获取填空题正确答案字符串
        GetFillBlankAnswersStr: function (Exercise) {
            Exercise.FillBlankAnswersStr = [];
            if (Exercise.FillBlankAnswers != null) {
                Exercise.FillBlankAnswers.forEach(function (item) {
                    var text = "";
                    item.FillBlankAnswerOptions.forEach(function (temp) {
                        text += temp.Content + "、";
                    })
                    Exercise.FillBlankAnswersStr.push(text.toString().substring(0, text.length - 1));
                })
            }
        },
        //获取选择填空题正确答案字符串
        GetChoiceFillBlankAnswersStr: function (Exercise) {
            Exercise.ChoiceFillBlankAnswersStr = [];
            Exercise.ChoiceFillBlankAnswers.forEach(function (item) {
                var text = "";
                item.ChoiceFillBlankAnswerOptions.forEach(function (temp) {
                    if (temp.IsAnswer) {
                        text += temp.Content + "、";
                    }
                })
                Exercise.ChoiceFillBlankAnswersStr.push(text.toString().substring(0, text.length - 1));
            })
        },
        //获取知识点
        getExerciseKeyPoint: function (id, callback) {
            let _this = this;
            tools.api('Exercise.GetKeyPointListByExerciseId', {"ExerciseId": id}, (data) => {
                let KeyPointName = "";
                if (data && data != "null") {
                    for (i = 0; i < data.length; i++) {
                        if (i == data.length - 1) {
                            KeyPointName += data[i].Name;
                        } else {
                            KeyPointName += data[i].Name + "、";
                        }
                    }
                }
                if (typeof callback == 'function') {
                    callback(KeyPointName);
                }
            });
        },
        //获取知识点
        getExerciseKeyPointList: function (ExerciseList) {
            let _this = this;
            let ids = [];
            ExerciseList.forEach(function (item) {
                ids.push(item.ExerciseId)
            })
            if (ids.length <= 0) {
                _this.isLoading = false;
                return false;
            }

            _this.getExerciseKeyPointListCommon(ids, function (KeyPointList) {
                ExerciseList.forEach(function (item) {
                    let KeyPoint = KeyPointList.find(el => {
                        return el.ExercixeId == item.ExerciseId
                    })
                    if (KeyPoint) {
                        item.KeyPointName = KeyPoint.KeyPointName;
                    }
                    //计算题还需要获取小题的知识点
                    if (item.ET == "Compute" || item.ET == "LargeChoiceFillBlank") {
                        let subExIds = [];
                        item.Questions.forEach(function (Questions) {
                            subExIds.push(Questions.ExerciseId);
                        })
                        _this.getExerciseKeyPointListCommon(subExIds, function (subKeyPointList) {
                            item.Questions.forEach(function (Questions) {
                                let subKeyPoint = subKeyPointList.find(el => {
                                    return el.ExercixeId == Questions.ExerciseId
                                })
                                if (subKeyPoint) {
                                    Questions.KeyPointName = subKeyPoint.KeyPointName;
                                }
                            })
                        })
                    }
                })
            })
        },
        getExerciseKeyPointListCommon: function (ExerciseIds, callback) {
            tools.api('Exercise.SearchKeyPointByExerciseIdsAsync', {"ExerciseIds": ExerciseIds}, (data) => {
                for (let item of data) {
                    item.KeyPointName = [];
                    for (let kp of item.KeyPointList) {
                        item.KeyPointName.push(kp.KeypointName);
                    }
                    item.KeyPointName = item.KeyPointName.join("、");
                }

                if (typeof callback == 'function') {
                    callback(data);
                }
            });
        },

        //获取习题页码和题号
        getExercisePageAndNumber: function (ExerciseList) {
            let _this = this;
            let ids = [];
            ExerciseList.forEach(function (item) {
                ids.push(item.ExerciseId)
            })
            if (ids.length <= 0) {
                _this.isLoading = false;
                return false;
            }
            tools.api('ExercisesPool.SearchExercisePageAndNumberAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "exerciseIdStr": ids.join(",")
            }, (data) => {
                data.forEach(function (item) {
                    _this.ExerciseList.forEach(function (item2) {
                        if (item2.ExerciseId == item.ExerciseId) {
                            item2.Page = item.Page;
                            item2.Number = item.Number;
                        }
                    })
                })
            });
        },

        //切页
        toPage: function (page) {
            this.pageIndex = page;
            this.isSelectAllExercise = false;
            if (this.isSearch) {
                this.ExerciseList = [];
                this.isLoading = true
                this.getExerciseList()
            } else {
                this.getExerciseList();
            }
        },

        //题型操作
        showExerciseTypeList: function () {
            this.isShowExerciseTypeList = !this.isShowExerciseTypeList;
        },
        showExerciseTypeAliasList: function (item) {
            this.exerciseTypeAliasList = item.ExerciseTypeAliasList;
            this.exerciseTypeId = item.ExerciseTypeId;
        },
        selectExerciseTypeAliasId: function (item) {
            this.exerciseTypeAliasId = item.ExerciseTypeAliasId;
            this.exerciseTypeName = item.Name;
            this.isShowExerciseTypeList = false;
            this.pageIndex = 1;
            this.getExerciseList();
        },
        selectExerciseTypeAliasId1: function (item) {
            window.burryPointHandler(
                {
                    'exerciseTypeAliasId': item.ExerciseTypeAliasId,
                    'exerciseTypeName': item.Name
                },
                'UCT2_5_2'
            )
            this.exerciseTypeAliasId = item.ExerciseTypeAliasId;
            this.exerciseTypeName = item.Name;
            this.isShowExerciseTypeList = false;
            this.pageIndex = 1;
            this.getExerciseList();
        },
        selectAllExerciseTypeId: function () {
            this.exerciseTypeAliasList = [];
            this.exerciseTypeId = -1;
            this.exerciseTypeAliasId = 0;
            this.exerciseTypeName = "全部题型";
            this.isShowExerciseTypeList = false;
            this.pageIndex = 1;
            this.getExerciseList();
        },
        closeExerciseTypeAliasList: function () {
            this.exerciseTypeAliasList = [];
            this.exerciseTypeId = -1;
        },

        //排序方式
        changeOrderby: function (sort) {
            window.burryPointHandler(
                {
                    'orderby': sort
                },
                'UCT2_5_3'
            )
            this.orderby = sort;
            this.pageIndex = 1;
            this.getExerciseList();
        },

        //删除习题
        removeSingleExercise: function (id) {
            window.burryPointHandler({'exerciseId': id}, 'UCT2_5_14')
            let _this = this;
            tools.api('ExercisePools.GetExerciseUseCount', {
                "exerciseId": id,
            }, (data) => {

                if (data > 0) {
                    tools.alertwar('习题已被使用，暂不支持删除')
                } else {
                    tools.alertconfim("确定删除该习题吗？", '', function () {
                        _this.removeExerciseCommon([id]);
                    });
                }
            });
        },
        removeExerciseCommon: function (ExerciseIds) {
            let _this = this;
            let schapid = ''
            if (_this.exercisePoolChapterActiveChapterId > 0) {
                schapid = _this.exercisePoolChapterActiveChapterId;
            } else {
                schapid = 0;
            }
            tools.api('ExercisesPool.RemoveExerciseAsync', {
                "ExercisePoolId": _this.exercisePoolId,
                "ExerciseIds": ExerciseIds,
                "EChapterId": schapid
            }, (data) => {
                if (_this.isSearch) {
                    _this.batchExerciseIds = [];
                    _this.ExerciseList = [];
                    _this.isLoading = true
                    _this.getExerciseList()
                } else {
                    _this.batchExerciseIds = [];
                    _this.getExerciseList();
                }
            });
        },

        //批量操作
        showBatchOption: function () {
            window.burryPointHandler(
                {},
                'UCT2_5_6'
            )
            this.isBatchOption = true;
            this.isSelectAllExercise = false;
            this.batchExerciseIds = [];
        },
        closeBatchOption: function () {
            this.isBatchOption = false;
            this.isSelectAllExercise = false;
            this.batchExerciseIds = [];
        },
        selectExercise: function (id) {
            let _this = this;
            if (this.batchExerciseIds.indexOf(id) > -1) {
                this.batchExerciseIds = this.batchExerciseIds.filter(function (item) {
                    return item != id;
                })
            } else {
                this.batchExerciseIds.push(id);
            }

            try {
                _this.ExerciseList.forEach((i, n) => {
                    if (_this.batchExerciseIds.indexOf(i.ExerciseId) == -1) {
                        _this.isSelectAllExercise = false

                        throw Error();
                    } else {
                        _this.isSelectAllExercise = true

                    }
                })
            } catch (e) {
            }

            if (_this.batchExerciseIds.length > 999) {
                _this.$message.error('最多仅支持批量操作999本题库');
            }
        },
        //重录
        reentryHandler: function (el) {
            console.log(el);
            const _this = this;
            _this.editExerciseType = 2;
            // 有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manual&expoolid=3118146279534&chaptername=相交线&chapterid=3118146279613
            // 没有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manual&expoolid=3118146279534&chaptername=全部习题
            let href = "";
            if (_this.chapterId > 0) {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&reentry=true&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&chaptername=" + _this.activeChapterName + "&reentrynum=" + el.Number + "&reentrypage=" + el.Page + "&reentryid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            } else {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&reentry=true&expoolid=" + _this.exercisePoolId + "&chaptername=全部习题" + "&reentrynum=" + el.Number + "&reentrypage=" + el.Page + "&reentryid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            }
            if (_this.fromBeike) {
                href = href + "&isShowKnowledgeArea=true";
            }
            _this.editExerciseIframe(href);
        },
        //重录--OCR
        reentryOCRHandler: function (el) {
            const _this = this;
            _this.editExerciseType = 2;

            //习题找图片
            tools.api('OCR.GetResourceByExerciseAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "exerciseIdStr": el.ExerciseId
            }, (data) => {
                if (data && data.length > 0 && data[0].ResourceList && data[0].ResourceList.length > 0) {
                    let resourceId = data[0].ResourceList[0].ResourceId;
                    let href = "";
                    if (_this.chapterId > 0) {
                        href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&reentry=true&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&chaptername=" + _this.activeChapterName + "&reentrynum=" + el.Number + "&reentrypage=" + el.Page + "&reentryid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                    } else {
                        href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&reentry=true&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chaptername=全部习题" + "&reentrynum=" + el.Number + "&reentrypage=" + el.Page + "&reentryid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                    }
                    if (_this.fromBeike) {
                        href = href + "&isShowKnowledgeArea=true";
                    }
                    _this.editExerciseIframe(href);
                } else {
                    _this.reentryHandler(el);
                }
            });
        },
        selectAllExercise: function () {

            let _this = this;
            this.isSelectAllExercise = !this.isSelectAllExercise;
            if (this.isSelectAllExercise) {
                for (let item of this.ExerciseList) {
                    // _this.batchExerciseIds.push(item.ExerciseId);
                    if (_this.batchExerciseIds.indexOf(item.ExerciseId) == -1) {
                        _this.batchExerciseIds.push(item.ExerciseId)
                    }
                }
            } else {
                // this.batchExerciseIds = [];

                _this.ExerciseList.forEach((i, n) => {
                    _this.batchExerciseIds.splice(_this.batchExerciseIds.findIndex(item => item === i.ExerciseId), 1)
                })
            }
            if (_this.batchExerciseIds.length > 999) {
                _this.$message.error('最多仅支持批量操作999本题库');
            }
            window.burryPointHandler({
                'batchExerciseIds': _this.batchExerciseIds
            }, 'UCT2_5_7')
        },
        //批量删除
        delSomeExercise: function (type, bors) {
            window.burryPointHandler({
                'batchExerciseIds': this.batchExerciseIds
            }, 'UCT2_5_10')
            let _this = this;
            if (_this.batchExerciseIds.length <= 0) {
                tools.alertwar("您还没有选择要删除的习题");
                return false;
            }
            _this.batchType = type;
            _this.batchOrSingle = bors;
            tools.alertconfim("确定批量删除习题吗？", '', function () {
                _this.removeExerciseCommon(_this.batchExerciseIds);
            });
        },
        //库内迁移  章节需要新增个 "不关联章节"
        moveSomeExercise: function (type, bors) {
            let _this = this;
            if (_this.batchExerciseIds.length <= 0) {
                tools.alertwar("您还没有选择要迁移的习题");
                return false;
            }
            _this.batchType = type;
            _this.batchOrSingle = bors;
            _this.isShowCatalogList = true;
            _this.exercisePoolChapterActiveChapterId = -1;
            tools.putLoading();
            _this.exercisePoolChapterList = [];
            _this.getPoolChapterCommon(_this.exercisePoolId, function (data) {
                _this.exercisePoolChapterList = data;
                tools.deleteLoading();
            })
            window.burryPointHandler({'exercisePoolId': _this.exercisePoolId}, 'UCT2_5_8')
        },
        //获取题库章节公共方法
        getPoolChapterCommon(exercisePoolId, callback) {
            let _this = this;
            let exercisePoolChapterList = [];
            tools.api('ExercisesPool.SearchPoolChapterAsync', {"exercisePoolId": exercisePoolId}, (data) => {
                for (let item of data) {
                    item.subChapterList = [];
                    item.subChapterList = data.filter(function (sub) {
                        return item.HexID == sub.ParentID
                    })
                    if (item.subChapterList.length > 0) {
                        item.isShowSub = true; //默认展开
                    }
                }
                exercisePoolChapterList = data.filter(function (item) {
                    return item.IsParent == true;
                });

                if (typeof callback == "function") {
                    callback(exercisePoolChapterList);
                }
            });
        },
        //更改当前选中章节
        changeActiveChapterIndex: function (id) {
            let _this = this;
            _this.exercisePoolChapterActiveChapterId = id;
        },
        //切换小节显示
        changeTreeShow: function (item) {
            item.isShowSub = !item.isShowSub;
        },
        closeCatalogList: function () {
            this.isShowCatalogList = false;
        },
        submitCatalogList: function () {
            let _this = this;
            //库内迁移
            _this.AddExerciseToPoolAndEChapter();
        },
        //添加题库到习题
        AddExerciseToPoolAndEChapter: function () {
            let _this = this;

            var schapid = "";
            if (_this.exercisePoolChapterActiveChapterId > 0) {
                schapid = _this.exercisePoolChapterActiveChapterId;
            } else {
                schapid = 0;
            }
            tools.putLoading();
            tools.api('ExercisesPool.AddExerciseListToPoolAndEChapter', {
                "ExercisePoolID": _this.exercisePoolId,
                "ExerciseIDs": _this.batchExerciseIds,
                "EChapterID": schapid
            }, (data) => {
                tools.deleteLoading();
                _this.closeCatalogList();
                tools.alertyes("库内迁移习题成功！", "", function () {
                    _this.isSelectAllExercise = false;
                    _this.batchExerciseIds = [];
                    _this.getExerciseList();
                })
            });
        },

        //批量复制
        //批量复制 如果有章节则选，没有则直接复制
        copySomeExercise: function (type, bors) {
            window.burryPointHandler({
                'type': type,
                'bors': bors
            }, 'UCT2_5_9')
            let _this = this;
            _this.batchType = type;
            _this.batchOrSingle = bors;
            if (_this.batchExerciseIds.length <= 0) {
                if (_this.batchType == "use") {
                    tools.alertwar("您还没有选择要采用的习题");
                } else if (_this.batchType == "copy") {
                    tools.alertwar("您还没有选择要复制的习题");
                }
                return false;
            }
            _this.copyExercisePoolChapterList = [];
            tools.putLoading();
            _this.getUserExercisePool(function () {
                _this.isShowCopyExercisePoolList = true;
                tools.deleteLoading();
            })
        },
        //单个采用或复制
        copySingleExercise: function (type, bors, exerciseId) {
            if (type == 'use') {
                window.burryPointHandler({}, 'UCT2_5_12')
            } else {
                window.burryPointHandler({}, 'UCT2_5_13')
            }
            let _this = this;
            _this.batchType = type;
            _this.batchOrSingle = bors;
            _this.batchExerciseIds = [];
            _this.batchExerciseIds.push(exerciseId);
            _this.copyExercisePoolChapterList = [];
            tools.putLoading();
            _this.getUserExercisePool(function () {
                _this.isShowCopyExercisePoolList = true;
                tools.deleteLoading();
            })
        },
        //获取我的题库
        getUserExercisePool: function (callback) {
            let _this = this;
            _this.copyExercisePoolList = [];
            _this.copyExercisePoolId = 0;
            if (_this.batchType == 'copy') {
                var json = {
                    "SubjectCourse": _this.subjectCourseId,
                    "where": _this.copyExercisePoolText,
                    "page": 1,
                    "rows": 1000,
                    "userid": tools.getCookie("UserId"),
                    "isInCludeJB": true,
                    "role": 3
                }
            } else {
                var json = {
                    "SubjectCourse": _this.subjectCourseId,
                    "where": _this.copyExercisePoolText,
                    "page": 1,
                    "rows": 1000,
                    "userid": tools.getCookie("UserId"),
                    "isInCludeJB": _this.jing == 3 ? true : false,
                    "role": 3
                }
            }
            if (_this.fromBeike) {
                delete json['role']
            }
            //获取课程资源包下，我创建题库
            tools.api('ExercisesPool.GetMyExercisePoolListBySubjectCourse', json, (data) => {
                let listDate = data.PoolInfos != null ? data.PoolInfos : [];
                listDate.forEach(function (item) {
                    _this.copyExercisePoolList.push(item);
                })

                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        //关键字搜索
        searchCopyExercisePoolList: function () {
            let _this = this;
            tools.putLoading();
            _this.getUserExercisePool(function () {
                tools.deleteLoading();
            })
            _this.copyExercisePoolId = 0;
        },
        changeCopyExercisePoolId: function (id) {
            this.copyExercisePoolId = id;

            let _this = this;
            _this.copyExercisePoolChapterActiveChapterId = -1;
            tools.putLoading();
            _this.copyExercisePoolChapterList = [];
            _this.getPoolChapterCommon(_this.copyExercisePoolId, function (date) {
                _this.copyExercisePoolChapterList = date;
                tools.deleteLoading();
            })
        },
        //更改当前选中章节
        changeCopyActiveChapterIndex: function (id) {
            let _this = this;
            _this.copyExercisePoolChapterActiveChapterId = id;
        },
        closeCopyExercisePoolList: function () {
            this.isShowCopyExercisePoolList = false;
        },
        submitCopyExercisePoolList: function () {
            //习题复制
            let _this = this;
            if (_this.copyExercisePoolId == 0) {
                tools.alertwar("您还没有选择题库");
                return false;
            }
            if (_this.batchType == "use") {
                _this.useExerciseToPoolAndEChapter();
            } else if (_this.batchType == "copy") {
                _this.copyEditExpoolExercise(_this.batchExerciseIds.join(","), function () {
                    _this.copyExerciseToPoolAndEChapter();
                });
            }
        },
        //复制习题
        copyExerciseToPoolAndEChapter: function () {
            let _this = this;

            var schapid = "";
            if (_this.copyExercisePoolChapterActiveChapterId > 0) {
                schapid = _this.copyExercisePoolChapterActiveChapterId;
            } else {
                schapid = 0;
            }
            tools.putLoading();
            tools.api('ExercisesPool.CopyBatchExercise', {
                "ExercisePoolId": _this.copyExercisePoolId,
                "ExerciseIds": _this.copyExerciseId,
                "EchapterId": schapid
            }, (data) => {
                tools.deleteLoading();
                _this.closeCatalogList();
                _this.closeCopyExercisePoolList();

                _this.isSelectAllExercise = false;
                _this.batchExerciseIds = [];
                tools.alertconfim("复制成功，是否要编辑该题？", "", function () {
                    _this.getExerciseList();
                    _this.copyExerciseIframe(schapid);
                })
            });
        },
        //采用习题
        useExerciseToPoolAndEChapter: function () {
            let _this = this;

            var schapid = "";
            if (_this.copyExercisePoolChapterActiveChapterId > 0) {
                schapid = _this.copyExercisePoolChapterActiveChapterId;
            } else {
                schapid = 0;
            }

            if (_this.isOCRExercisePool) {
                tools.api('OCR.GetResourceByExerciseAsync', {
                    "exercisePoolId": _this.exercisePoolId,
                    "exerciseIdStr": _this.batchExerciseIds.join(",")
                }, (data) => {
                    //如果没有图片，则不返回数据
                    let ExerciseResourcesModels = [];
                    for (let item of _this.batchExerciseIds) {
                        let Resources = data.find(function (resourcesItem) {
                            return resourcesItem.ExerciseId == item;
                        })
                        if (Resources) {
                            let ResourceIdList = [];
                            Resources.ResourceList.forEach(function (resource) {
                                ResourceIdList.push(resource.ResourceId)
                            })
                            ExerciseResourcesModels.push({
                                "ExerciseID": Resources.ExerciseId,
                                "ResourceID": ResourceIdList.join(","),
                                "ExerciseNumber": Resources.ExerciseNumber
                            })
                        } else {
                            ExerciseResourcesModels.push({"ExerciseID": item})
                        }
                    }
                    _this.useExerciseToPoolAndEChapterCommon(ExerciseResourcesModels, schapid);
                });
            } else {
                let ExerciseResourcesModels = [];
                _this.batchExerciseIds.forEach(function (item) {
                    ExerciseResourcesModels.push({"ExerciseID": item})
                })
                _this.useExerciseToPoolAndEChapterCommon(ExerciseResourcesModels, schapid);
            }
        },
        useExerciseToPoolAndEChapterCommon: function (ExerciseResourcesModels, schapid) {
            let _this = this;

            tools.putLoading();
            tools.api('ExercisesPool.BatchUsedExerciseAsync', {
                "ExercisePoolID": _this.copyExercisePoolId,
                "ExerciseResourcesModels": ExerciseResourcesModels,
                "HexID": schapid
            }, (data) => {
                tools.deleteLoading();
                _this.closeCatalogList();
                _this.closeCopyExercisePoolList();
                tools.alertyes("采用习题成功！", "", function () {
                    _this.isSelectAllExercise = false;
                    _this.batchExerciseIds = [];
                    _this.getExerciseList();
                })
            }, function () {
                tools.deleteLoading();
            });
        },


        //预览与精简模式
        changeViewType: function (viewType) {
            if (viewType === 1) {
                window.burryPointHandler({
                    'viewType': viewType
                }, 'UCT2_5_4')
            } else {
                window.burryPointHandler({
                    'viewType': viewType
                }, 'UCT2_5_5')
            }
            this.viewType = viewType;

            //预览模式，加载知识点
            if (this.viewType == 1) {
                this.getExerciseKeyPointList(this.ExerciseList);
            }

            // //渲染latex
            // this.$nextTick(function () {
            //     tools.initLatex($(".exercise"));
            //     tools.initImg($(".exercise"));
            // })
        },

        //关闭组件
        closeExpoolExercise: function () {
            const _this = this;
            _this.$emit('closeExpoolExercise', 0);
        },

        //编辑习题
        gotoEditExercise: function (el, isNewEdition) {
            let _this = this;
            if (_this.isSearch) {
                _this.chapterId = el.sectionID
            }
            window.burryPointHandler({'chapterId': _this.chapterId}, 'UCT2_5_11')

            //习题找图片
            tools.api('OCR.GetResourceByExerciseAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "exerciseIdStr": el.ExerciseId
            }, (data) => {
                if (data && data.length > 0 && data[0].ResourceList && data[0].ResourceList.length > 0) {
                    let resourceId = data[0].ResourceList[0].ResourceId;
                    let href = "";
                    if (isNewEdition) {
                        //文科
                        //https://artsentryexe.hexfuture.net/index.html#type=chief&mode=ocr&cmsid=2585629331338&expoolid=3027952048249&chapterid=3027952075786&exid=3027952125037
                        // href = tools._exerciseInput_arts + "index.html#type=chief&mode=ocr&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&exid=" + el.ExerciseId;
                        if (_this.jing == 3 || _this.jing == 5) {
                            href = tools._exerciseInput_arts + "index.html#type=chief&version=bph&mode=ocr&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.activeChapterId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                        } else {
                            href = tools._exerciseInput_arts + "index.html#type=chief&mode=ocr&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.activeChapterId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                        }
                    } else {
                        //弃用
                        //理科
                        //https://exerciseocr.hexfuture.net/index.html#type=chief&cmsid=2585627248597&expoolid=3027952024611&exid=1
                        href = tools._exerciseInput + "index.html#type=chief&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&exid=" + el.ExerciseId;
                    }
                    tools.OpenHref(href, "_blank");
                } else {
                    // tools.alertwar("未找到习题对应图片！");
                    _this.editExpoolExercise(el);
                }
            });
        },
        bathUploadFile: function () {
            const _this = this;
            let href = tools._newEditor + "batch-upload-file" + '/0' + '/' + _this.subjectCourseId + '/' +'0' +'/'+ _this.exercisePoolId +'/0/0?chapterId='+ (_this.chapterId == -1 ? 0:_this.chapterId);
            window.open(href,'_blank');
        },
        //=============创建编辑习题start================
        //添加习题
        addExpoolExercise: function () {
            const _this = this;
            _this.editExerciseType = 0;
            // 有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manual&expoolid=3118146279534&chaptername=相交线&chapterid=3118146279613
            // 没有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manual&expoolid=3118146279534&chaptername=全部习题
            let href = "";
            if (_this.chapterId > 0) {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&chaptername=" + _this.activeChapterName + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            } else {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manual&expoolid=" + _this.exercisePoolId + "&chaptername=全部习题" + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            }
            if (_this.fromBeike) {
                href = href + "&isShowKnowledgeArea=true";
            }
            _this.editExerciseIframe(href);
        },
        //编辑习题
        editExpoolExercise: function (el) {
            console.log('editExpoolExercise');

            const _this = this;
            _this.editExerciseType = 1;
            if (_this.isSearch) {
                _this.chapterId = el.sectionID
            }

            // 有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualedit&expoolid=3118146279534&chapterid=3118146279613&exid=863289169381
            // 没有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualedit&expoolid=3118146279534&exid=863289169381
            let href = "";
            if (_this.chapterId > 0) {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            } else {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&expoolid=" + _this.exercisePoolId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            }
            if (_this.fromBeike) {
                href = href + "&isShowKnowledgeArea=true";
            }
            _this.editExerciseIframe(href);
        },
        // 换一道题
        changeExpoolExercise: function (el) {
            console.log('changeExpoolExercise');

            const _this = this;
            _this.editExerciseType = 3;
            if (_this.isSearch) {
                _this.chapterId = el.sectionID
            }

            // 有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualedit&expoolid=3118146279534&chapterid=3118146279613&exid=863289169381
            // 没有章节：
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualedit&expoolid=3118146279534&exid=863289169381
            let href = "";
            if (_this.chapterId > 0) {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&changeexe=true&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            } else {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&changeexe=true&expoolid=" + _this.exercisePoolId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            }
            if (_this.fromBeike) {
                href = href + "&isShowKnowledgeArea=true";
            }
            _this.editExerciseIframe(href);
        },
        // 换一道题--OCR
        changeOCRExpoolExercise: function (el) {
            let _this = this;
            _this.editExerciseType = 3;
            if (_this.isSearch) {
                _this.chapterId = el.sectionID
            }

            //习题找图片
            tools.api('OCR.GetResourceByExerciseAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "exerciseIdStr": el.ExerciseId
            }, (data) => {
                if (data && data.length > 0 && data[0].ResourceList && data[0].ResourceList.length > 0) {
                    let resourceId = data[0].ResourceList[0].ResourceId;
                    let href = "";
                    if (_this.chapterId > 0) {
                        href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&changeexe=true&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.chapterId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                    } else {
                        href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualedit&changeexe=true&cmsid=" + resourceId + "&expoolid=" + _this.exercisePoolId + "&exid=" + el.ExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                    }
                    if (_this.fromBeike) {
                        href = href + "&isShowKnowledgeArea=true";
                    }
                    _this.editExerciseIframe(href);
                } else {
                    _this.changeExpoolExercise(el);
                }
            });
        },
        editExerciseIframe: function (href) {
            const _this = this;
            _this.isShowEditExerciseList = true;
            _this.editExerciseIframeSrc = href;
            _this.editExerciseIframeLoading = true;
            if (_this.editExerciseType == 0 || _this.editExerciseType == 2) {
                // _this.openFullScreen();
            }
            _this.$nextTick(function () {
                let iframe = document.getElementById("editExerciseIframe");
                iframe.onload = function () {
                    console.log("iframe.onload");
                    _this.editExerciseIframeLoading = false;
                };
            })
        },
        closeEditExerciseList: function () {
            const _this = this;
            _this.exerciseInputIframePostMessage(function () {
                console.log('触发渲染回调')
                _this.isShowEditExerciseList = false;
                if (_this.editExerciseType == 0 || _this.editExerciseType == 2) {
                    // _this.closeFullScreen();
                }
                if (_this.isSearch) {

                    _this.getExerciseList();
                    _this.ExerciseList = [];
                    _this.isLoading = true
                } else {

                    _this.getExerciseList();
                    _this.changeExercisePoolExcount();
                }
            })
        },
        //=============创建编辑习题end================

        //=============编辑复制的习题start============
        copyEditExpoolExercise: function (exerciseId, callback) {
            const _this = this;

            tools.api('ExercisesPool.CopyExerciseByExerciseId', {
                "ExerciseId": exerciseId,
            }, (data) => {
                _this.copyExerciseId = data;
                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        copyExerciseIframe: function (schapid) {
            const _this = this;
            // （有章节）
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualcopy&expoolid=3118146279534&chaptername=相交线&chapterid=3118146279613&exid=863289169381
            // （没有章节）
            // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=manualcopy&expoolid=3118146279534&chaptername=全部习题&exid=863289169381
            let href = "";
            if (schapid > 0) {
                //获取节名称
                let activeChapterName = "";
                let activeChapterNameList = [];
                for (let item of _this.copyExercisePoolChapterList) {
                    activeChapterNameList.push(item);
                    for (let sub of item.subChapterList) {
                        activeChapterNameList.push(sub);
                        for (let sub2 of sub.subChapterList) {
                            activeChapterNameList.push(sub2);
                        }
                    }
                }
                for (let item of activeChapterNameList) {
                    if (schapid == item.HexID) {
                        activeChapterName = item.HexName
                    }
                }
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualcopy&expoolid=" + _this.copyExercisePoolId + "&chapterid=" + schapid + "&chaptername=" + activeChapterName + "&exid=" + _this.copyExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            } else {
                href = tools._exerciseInput_arts + "index.html#type=chief&mode=manualcopy&expoolid=" + _this.copyExercisePoolId + "&chaptername=全部习题" + "&exid=" + _this.copyExerciseId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
            }

            _this.isShowCopyEditExerciseList = true;
            _this.copyExerciseIframeSrc = href;
            _this.copyExerciseIframeLoading = true;
            _this.$nextTick(function () {
                let iframe = document.getElementById("copyExerciseIframe");
                iframe.onload = function () {
                    console.log("copyExerciseIframe.onload");
                    _this.copyExerciseIframeLoading = false;
                };
            })
        },
        closeCopyExerciseList: function () {
            const _this = this;
            _this.isShowCopyEditExerciseList = false;
        },
        exerciseCopyIframeEventListener: function (e) {
            let _this = this;
            if (e.data.method == "copySuccess" && e.data.copysuccess == true) {
                console.log("监听事件触发:复制习题编辑完成");
                _this.isShowCopyEditExerciseList = false;
            }
        },
        //=============编辑复制的习题end================

        //========与录入习题交互start============
        exerciseInputIframePostMessage: function (callback) {
            var obj = {isCheckStriding: false, operation: "checkEx", timestamp: new Date().getTime()};
            document.getElementById('editExerciseIframe').contentWindow.postMessage(obj, "*");

            let _this = this;
            _this.editExerciseIframeCallback = callback;
        },
        exerciseInputIframeEventListener: function (e) {
            console.log('接受到了信息')
            let _this = this;
            if (e.data.operation == "checkExBack") {
                console.log("监听事件触发:是否有未保存的习题" + e.data.count);
                let count = parseInt(e.data.count);
                if (count > 0) {
                    _this.isShowEditExerciseIframeConfim = true;
                } else {
                    if (typeof _this.editExerciseIframeCallback == "function") {
                        _this.editExerciseIframeCallback();
                    }
                }
            } else if (e.data.method == "backToExList") {
                console.log("监听事件触发:批量录入习题返回");
                _this.closeEditExerciseList();
            }
        },
        toSaveEx: function () {
            let _this = this;
            _this.isShowEditExerciseIframeConfim = false;
        },
        noSaveEx: function () {
            let _this = this;
            _this.isShowEditExerciseIframeConfim = false;
            if (typeof _this.editExerciseIframeCallback == "function") {
                _this.editExerciseIframeCallback();
            }
        },
        //========与录入习题交互end============
        //与父页面交互
        changeExercisePoolExcount: function () {
            const _this = this;
            _this.$emit('changeExercisePoolExcount');
        },

        //全屏
        openFullScreen() {
            var element = document.documentElement;
            // 判断浏览器设备类型
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {   // 兼容火狐
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {    // 兼容谷歌
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {   // 兼容IE
                element.msRequestFullscreen();
            }
        },
        closeFullScreen() {
            //  退出全屏
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        },


        //========题号和页码的方法start============
        //获取页码集合
        getPageOrderList() {
            let _this = this;
            _this.pageOrderList = [];
            _this.pageOrderList.push({"Key": "", "Name": "全部"});
            _this.pageOrderList.push({"Key": "-1", "Name": "未标记"});
            tools.api('ExercisesPool.GetExercisePoolPageNumsAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "echapterIdStr": _this.chapterIds == -1 ? undefined : _this.chapterIds,
            }, (data) => {
                data.map(function (item) {
                    if (!isNaN(parseInt(item.PageNum))) {
                        let PageNum = "P" + item.PageNum;
                        _this.pageOrderList.push({"Key": item.PageNum, "Name": PageNum});
                    } else {
                        _this.pageOrderList.push({"Key": item.PageNum, "Name": item.PageNum});
                    }
                })
                if (_this.pageOrderId == "") {
                    _this.pageOrderId = _this.pageOrderList[0].Key;
                    _this.pageOrderName = _this.pageOrderList[0].Name;
                }
            });
        },
        setFontSize() {
            let that = this;
            tools.api('ExercisesPool.GetExerciseBookSubjectCourse', {
                "ExerciseBookID": that.exercisePoolId
            }, (res) => {
                tools.api('ExercisesPool.GetSubjectBySubjectCourseID', {
                    "SubjectCourseId": res.subjectCourseID
                }, (data) => {
                    // HexFont.init({SubjectType:data.SubjectType,dom_targetDiv:'.questionArea'})
                    tools.checkFont($('.fontTest')[0])
                    var timer;
                    timer = setInterval(function () {
                        if (window.fontIsReady) {
                            clearInterval(timer)

                            HexFont.init({SubjectType: data.SubjectType, dom_targetDiv: '.questionArea'})
                        }
                    }, 100)
                });
            });

        },
        //更改选中页码
        changePageOrderList(one) {
            let _this = this;
            _this.pageOrderId = one.Key;
            _this.pageOrderName = one.Name;
            this.pageIndex = 1;
            this.getExerciseList();
        },
        //设置习题题号
        setExNumber(one) {
            let _this = this;
            if (one.Number && one.Number.length > 0) {
                tools.api('ExercisesPool.SaveExerciseNumberAsync', {
                    "ExercisePoolId": _this.exercisePoolId,
                    "ExerciseId": one.ExerciseId,
                    "ExerciseNumber": one.Number
                }, (data) => {
                    _this.getExerciseList();
                });
            }
        },
        //生成页码
        createPageNum() {
            let _this = this;
            if (_this.batchExerciseIds.length <= 0) {
                tools.alertwar("您还没有选择要生成页码的习题");
                return false;
            }

            _this.isShowCreatePageNum = true;
            _this.createPageNumType = "input";
            _this.PageNumCount = 0;
            _this.PageNumList = [];
            tools.api('ExercisesPool.GetExercisePoolPageNumsAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "echapterIdStr": _this.chapterIds == -1 ? undefined : _this.chapterIds,
            }, (data) => {
                data.map(function (item) {
                    if (!isNaN(parseInt(item.PageNum))) {
                        let PageNum = "P" + item.PageNum;
                        _this.PageNumList.push({"Key": item.PageNum, "Name": PageNum});
                    } else {
                        _this.PageNumList.push({"Key": item.PageNum, "Name": item.PageNum});
                    }
                })
                if (_this.PageNumList.length > 0) {
                    _this.PageNumId = _this.PageNumList[0].Key;
                    _this.PageNumName = _this.PageNumList[0].Name;
                }

                this.$nextTick(function () {
                    HexSelector.init();
                });
            });
        },
        closeCreatePageNum() {
            let _this = this;
            _this.isShowCreatePageNum = false;
        },
        changePageNumType(type) {
            this.createPageNumType = type;
        },
        changePageNum(one) {
            let _this = this;
            _this.PageNumId = one.Key;
            _this.PageNumName = one.Name;
        },
        submitCreatePageNum() {
            let _this = this;
            if (_this.createPageNumType == "input") {
                if (_this.PageNumCount.length <= 0) {
                    tools.alertwar("您还没有填写要创建新页码");
                    return false;
                }
                //页码是否已存在
                let PageNum = _this.PageNumList.find(function (item) {
                    return item.Key == _this.PageNumCount
                })
                if (PageNum) {
                    _this.showCreatePageNumError();
                    return false;
                } else {
                    tools.api('ExercisesPool.CreateExercisePoolPageNumAsync', {
                        "ExercisePoolId": _this.exercisePoolId,
                        "EChapterPageNums": [{
                            "EChapterId": _this.chapterIds == -1 ? 0 : _this.chapterIds.split(',')[0],
                            "PageNum": _this.PageNumCount
                        }],
                    }, (data) => {
                        tools.api('ExercisesPool.UpdateExercisePageNumAsync', {
                            "ExercisePoolId": _this.exercisePoolId,
                            "ExerciseIds": _this.batchExerciseIds,
                            "PageNum": _this.PageNumCount,
                        }, (data) => {
                            _this.closeCreatePageNum();
                            _this.isSelectAllExercise = false;
                            _this.batchExerciseIds = [];
                            _this.getExerciseList();
                            _this.getPageOrderList();
                        });
                    });
                }
            } else if (_this.createPageNumType == "select") {
                tools.api('ExercisesPool.UpdateExercisePageNumAsync', {
                    "ExercisePoolId": _this.exercisePoolId,
                    "ExerciseIds": _this.batchExerciseIds,
                    "PageNum": _this.PageNumId,
                }, (data) => {
                    _this.closeCreatePageNum();
                    _this.isSelectAllExercise = false;
                    _this.batchExerciseIds = [];
                    _this.getExerciseList();
                });
            }
        },
        showCreatePageNumError() {
            let _this = this;
            _this.isShowCreatePageNumError = true;
        },
        closeCreatePageNumError() {
            this.isShowCreatePageNumError = false;
        },
        //归入已有
        asExisting() {
            let _this = this;
            tools.api('ExercisesPool.UpdateExercisePageNumAsync', {
                "ExercisePoolId": _this.exercisePoolId,
                "ExerciseIds": _this.batchExerciseIds,
                "PageNum": _this.PageNumCount,
            }, (data) => {
                _this.closeCreatePageNum();
                _this.isSelectAllExercise = false;
                _this.batchExerciseIds = [];
                _this.getExerciseList();

                _this.closeCreatePageNumError();
            });
        },
        annotationpic() {

            let that = this;
            //this.ExerciseBookId=query.ExerciseBookId,
            this.$tools.api(
                "ExercisesPool.SearchMarkTreeEChapter",
                {
                    poolId: that.exercisePoolId,
                    //poolId:'3027952445156'
                },
                function (res) {
                    that.remarklist = res;
                    that.annotationDig = true
                },
                function () {
                    that.$message({
                        message: "请求失败",
                        type: "error",
                    });
                }
            );
        },

        changeAhzType(query) {
            switch (query) {
                case "0":
                    this.createPageNum()
                    break;
                case "1":
                    this.moveSomeExercise('move', 'batch')
                    break;
                case "2":
                    this.copySomeExercise('use', 'batch')
                    break;
                case "3":
                    this.delSomeExercise('del', 'batch')
                    break;
            }
        },


        //重新输入
        reEnter() {
            let _this = this;
            _this.closeCreatePageNumError();
            _this.createPageNum();
        },
        //========题号和页码的方法end============
        //单独设置页码1:获取以前的老页码
        setPage(pageNum) {
            let nowPageNum = pageNum.Page
            if (!isNaN(nowPageNum)) {
                if (nowPageNum.toString().indexOf('-') !== -1) {
                    this.$message.error('页码不能为负,请输入正确的数字!')
                    this.getExerciseList();
                    pageNum.Page = ''
                    return false
                } else if (nowPageNum.toString().indexOf('.') + 1 > 0) {
                    this.$message.error('页码不能为小数,请输入正确的数字!')
                    this.getExerciseList();
                    pageNum.Page = ''
                    return false
                }
                nowPageNum.length != 0 ? nowPageNum : nowPageNum = 0
                nowPageNum = nowPageNum.replace(/[^0-9]/ig, "")
                let _this = this;
                tools.api('ExercisesPool.GetExercisePoolPageNumsAsync', {
                    "exercisePoolId": _this.exercisePoolId,
                    "echapterIdStr": _this.chapterIds == -1 ? undefined : _this.chapterIds,
                }, (data) => {
                    _this.oldpageNum = [];
                    data.map(function (item) {
                        _this.oldpageNum.push(item.PageNum)
                    })
                    _this.checkedPage(pageNum.sectionID, nowPageNum, pageNum.ExerciseId)
                });
            } else {
                this.$message.error('页码请输入正确的数字!')
                this.getExerciseList();
                pageNum.Page = ''
                return false
            }
        },
        goRemake(res, data) {
            if (data.ResourceIDs != null) {
                let url = `https://artsentryexe.hexfuture.net/index.html#type=chief&mode=category&version=bph&scene=check&cmsid=${data.ResourceIDs.join(',')}&expoolid=${this.exercisePoolId}&chapterid=${data.EChapterID}`
                window.open(url, '_blank');
            }


        },

        //单独设置页码2:输入页码是否为老页码
        checkedPage(sectionID, page, ExerciseId) {
            console.log(sectionID)
            let _this = this;
            console.log(_this.oldpageNum.indexOf(page))
            if (_this.oldpageNum.indexOf(page) == -1) {

                tools.api('ExercisesPool.CreateExercisePoolPageNumAsync', {
                    "ExercisePoolId": _this.exercisePoolId,
                    "EChapterPageNums": [{
                        "EChapterId": _this.chapterIds == -1 ? undefined : _this.chapterIds.split(',')[0],
                        "PageNum": page
                    }],
                }, (data) => {
                    tools.api('ExercisesPool.UpdateExercisePageNumAsync', {
                        "ExercisePoolId": _this.exercisePoolId,
                        "ExerciseIds": [ExerciseId],
                        "PageNum": page,
                    }, (data) => {
                        if (_this.isSearch) {
                            _this.getExerciseList();
                            _this.ExerciseList = [];
                            _this.isLoading = true
                            _this.getPageOrderList();
                        } else {
                            _this.getExerciseList();
                            _this.getPageOrderList();
                        }
                    });
                });
            } else {
                tools.api('ExercisesPool.UpdateExercisePageNumAsync', {
                    "ExercisePoolId": _this.exercisePoolId,
                    "ExerciseIds": [ExerciseId],
                    "PageNum": page,
                }, (data) => {
                    if (_this.isSearch) {
                        _this.getExerciseList();
                        _this.ExerciseList = [];
                        _this.isLoading = true
                        _this.getPageOrderList();
                    } else {
                        _this.getExerciseList();
                        _this.getPageOrderList();
                    }
                });
            }
        }
    }
}
